<template>
  <div class='core'>
    <div class='layui-layer-title' style='cursor: move;'>{{ title }}</div>
    <div class='layui-layer-content'>
      <div class='layui-layer-wrap'>
        <div class='form-collapse'>
          <div class='info'>
            <layui-form ref='robotManageMngRef' :show-form='true' :after-save='handleAfterSave' :rule='robotManageFormRule' :requestUniqueId='requestId'>
              <template slot-scope='{scope}'>
                <div class='layui-form'>
                  <template>
                    <layui-collapse>
                      <div class='layui-colla-item'>
                        <h2 class='layui-colla-title'>机器人基本信息</h2>
                        <div class='layui-colla-content layui-show'>
                          <div class='layui-form-item-two'>
                            <div class='layui-form-item-left'>
                              <div class='pub-form'>
                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>webhook链接：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.WEBHOOK' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='WEBHOOK' placeholder='请输入webhook链接'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>公司名称：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.COMPANY_NAME' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='COMPANY_NAME' placeholder='请输入公司名称'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class="layui-form-label"><span class="x-red">*</span>品牌名称： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <layui-multiselect
                                      :single="true"
                                      ref="brandSelect"
                                      :enabled="!isBrowserStatus"
                                      name="BRAND_ID"
                                      @selectChange="brandChange($event)"
                                      table-name="YW_BRAND_DETAIL_V"
                                      text-field="BRAND_NAME"
                                      value-field="BRAND_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.BRAND_ID"
                                    ></layui-multiselect>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>门店：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <layui-tableselect
                                      v-if="!isBrowserStatus"
                                      name="CUSTOMER_STORE_IDS"
                                      table-name="YW_CUS_STORE_DETAIL_V1"
                                      @selectChange='storeOnChange($event)'
                                      :renderText="renderClientText"
                                      input-width="100%"
                                      table-width="800px"
                                      text-width="100%"
                                      text-field="STORE_NAME"
                                      value-field="STORE_ID"
                                      queryFields="CLIENT_NAME,STORE_NAME,BRAND_NAME"
                                      v-model="config.form.CUSTOMER_STORE_IDS"
                                      :tip="tipAlert"
                                      :sort="['CREATE_TIME:DESC']"
                                      :page-size="50"
                                      :page-range="6"
                                      :page-options="[15, 25, 50, 100]"
                                      style="width:400px"
                                      :multiTableList="storeList"
                                      :removeType="removeType"
                                      :defaultCondition="{'STORE_MANAGER_ID:8': ''}"
                                      fieldFilter="STORE_ID"
                                    >
                                      <div>
                                        <div radio="true"></div>
                                        <div field="STORE_NAME" title="门店" width="220"></div>
                                        <div field="CLIENT_NAME" title="客户" width="280"></div>
                                        <div field="BRAND_NAME" title="品牌" width="120"></div>
                                        <div field="MANAGER_NAME" title="项目经理" width="120"></div>
                                        <div field="PROVINCE_DESC" title="省" ></div>
                                        <div field="CITY_DESC" title="市" ></div>
                                        <div field="DISTRICT_DESC" title="县" ></div>
                                      </div>
                                    </layui-tableselect>
                                    <input v-else type='text' v-model='customerStoreExtNames' autocomplete='off' class="layui-input layui-disabled" />
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>提醒人员：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <layui-multiselect
                                      :single="true"
                                      ref="wxPsnSelectRef"
                                      :enabled="!isBrowserStatus"
                                      name="PSN_ID"
                                      @selectChange="wxPsnOnChange($event)"
                                      table-name="YW_ROBOT_WX_PSN"
                                      text-field="PSN_NAME"
                                      value-field="PSN_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.PSN_ID"
                                    />
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>提醒结束语：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.WARN_SUFFIX' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='WARN_SUFFIX' placeholder='请输入提醒结束语'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'></label>
                                  <div class='layui-input-inline' style='width: 60%; color: #959595'>
                                    示例：以上提醒为保内报修，如是保外请与报修人员联系！
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>分类标签：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.CLASSIFY_TAG' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='CLASSIFY_TAG' placeholder='请输入分类标签'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>备注：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <textarea  :disabled="isBrowserStatus" v-model='config.form.MEMO' autocomplete='off' :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'" name='MEMO' placeholder='请输入备注'/>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>

                <div class='layui-form-btn'>
                  <div class='layui-footer'>
                    <button class='layui-btn refresh' title='关闭' @click='onCancelBtn()'>关 闭</button>
                    <button class='layui-btn' v-if="!isBrowserStatus" title='保存' @click='onSaveBtn()'>保 存</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestId: 'repairRobotFormRequest',
      robotManageFormRule: {
        WEBHOOK: {required: {message: 'webhook链接不能为空'}},
        COMPANY_NAME: {required: {message: '公司名称不能为空'}},
        BRAND_ID: {required: {message: '品牌名称不能为空'}},
      },
      config: {form: {}},
      formData: {},
      title: '',
      storeList: [],
      removeType: '',
      tipAlert: "请选择客户",
      isBrowserStatus: false,
      customerStoreExtNames: '',
    }
  },

  mounted() {
    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title

      if (this.formType === 'browser') {
        this.config.form = this.formData
        this.removeType = 'multi-remove'
        this.tipAlert = ""
        this.isBrowserStatus = true
        this.customerStoreExtNames = this.formData.CUSTOMER_STORE_EXT_NAMES
      }

      if (this.formType === 'edit') {
        this.config.form = this.formData
        this.removeType = 'multi-remove'
        this.tipAlert = ""
      }
    }
  },

  methods: {
    handleAfterSave() {
      this.baseComponent.loadComponentByName('robotManage')

      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },

    //品牌变化
    brandChange(data) {
      if (data.length > 0) {
        this.config.form['BRAND_ID'] = data[0]._row.BRAND_ID
        this.config.form['BRAND_NAME'] = data[0]._row.BRAND_NAME
      } else {
        this.config.form.BRAND_ID = ''
        this.config.form.BRAND_NAME = ''
        this.$refs.brandSelect.queryCondition.BRAND_NAME = ''
        this.$refs.brandSelect.refreshAsyncData()
      }
    },

    onCancelBtn() {
      // this.baseComponent.loadComponentByName('qrCodeManage')
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
    },

    renderClientText(row) {
      if (row) {
        if (!row.STORE_ID) {
          return '--请选择--'
        } else {
          var arr = [];
          arr.push('门店【 ' + row['STORE_NAME'] + ' 】');
          this.storeName = arr.join(" ")
          return arr.join(" ");
        }
      }
    },
    wxPsnOnChange(selectData) {
      if (selectData != null && selectData.length > 0) {
        this.config.form['PSN_ID'] = selectData[0].value
        this.config.form['PSN_NAME'] = selectData[0].name
      } else {
        this.config.form['PSN_ID'] = ''
        this.config.form['PSN_NAME'] = ''
      }
    },
    onSaveBtn() {
      this.$refs.robotManageMngRef.editRow = this.config.form
      if (!this.config.form.CUSTOMER_STORE_IDS) {
        layer.msg('门店不能为空', {icon: 5,shift: 6});
        return
      }
      if (!this.config.form['PSN_ID'] || !this.config.form['PSN_NAME']) {
        layer.msg('提醒人员不能为空', {icon: 5,shift: 6});
        return
      }
      this.$refs.robotManageMngRef.callableSave('YW_ROBOT')
    },

    storeOnChange(selectData) {
      if (this.formType === 'edit') {
        // 修改状态，如果已经存在，则在此基础上删除  此时selectData为对象
        let customer_store_ids = this.config.form['CUSTOMER_STORE_IDS'];
        let customer_store_ext_names = this.config.form['CUSTOMER_STORE_EXT_NAMES'];

        if (selectData && selectData.hasOwnProperty("STORE_ID")) {
          let customer_store_id_array = [];
          let customer_store_ext_name_array = [];

          if (customer_store_ids && customer_store_ids.length > 0) {
            customer_store_id_array = customer_store_ids.split(',')
            customer_store_ext_name_array = customer_store_ext_names.split(',')
          }

          customer_store_id_array.remove((selectData.STORE_ID).toString())
          customer_store_ext_name_array.remove(selectData.STORE_NAME)

          // this.storeList = selectData;
          this.tipAlert = ""
          this.config.form['CUSTOMER_STORE_IDS'] = customer_store_id_array.join(",");
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = customer_store_ext_name_array.join(",");
        } else {
          // 修改状态，如果已经存在，则在此基础上添加  此时selectData 为数组
          if (customer_store_ids) {
            let customer_store_id_arr = []
            customer_store_id_arr  = customer_store_ids.split(',')
            let customer_store_ext_name_arr = []
            customer_store_ext_name_arr = customer_store_ext_names.split(',')

            customer_store_id_arr.push(selectData[0]['STORE_ID'].toString());
            let new_customer_store_ext_ids =customer_store_id_arr;
            customer_store_ext_name_arr.push(selectData[0]['STORE_NAME']);
            let new_customer_store_ext_names = customer_store_ext_name_arr

            this.tipAlert = ""
            this.config.form['CUSTOMER_STORE_IDS'] = new_customer_store_ext_ids.join(",");
            this.config.form['CUSTOMER_STORE_EXT_NAMES'] = new_customer_store_ext_names.join(",");
          } else {
            let customer_store_id_arr = []
            let customer_store_ext_name_arr = []

            customer_store_id_arr.push(selectData[0]['STORE_ID'].toString());
            let new_customer_store_ext_ids =customer_store_id_arr;
            customer_store_ext_name_arr.push(selectData[0]['STORE_NAME']);
            let new_customer_store_ext_names = customer_store_ext_name_arr

            this.tipAlert = ""
            this.config.form['CUSTOMER_STORE_IDS'] = new_customer_store_ext_ids.join(",");
            this.config.form['CUSTOMER_STORE_EXT_NAMES'] = new_customer_store_ext_names.join(",");
          }
        }
      } else {
        if (selectData != null && selectData.length > 0) {
          let customer_store_id_array = [];
          let customer_store_ext_name_array = [];

          for (let item of selectData) {
            customer_store_id_array.push(item.STORE_ID)
            customer_store_ext_name_array.push(item.STORE_NAME)
          }

          this.storeList = selectData;
          this.tipAlert = ""
          this.config.form['CUSTOMER_STORE_IDS'] = customer_store_id_array.join(",");
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = customer_store_ext_name_array.join(",");
        } else {
          this.tipAlert = "请选择客户"
          this.config.form['CUSTOMER_STORE_EXT_IDS'] = "";
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = "";
        }
      }


    }


  }
}
</script>




// WEBPACK FOOTER //
// src/components/repairs/robotManage/robotManageForm.vue